// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-wrapper{line-height:0}`, "",{"version":3,"sources":["webpack://./app/components/svgs/SvgWrapper/SvgWrapper.scss"],"names":[],"mappings":"AAAA,aACE,aAAA","sourcesContent":[".svg-wrapper {\n  line-height: 0; // remove space below svg and allows for proper vertical alignment\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
